import { render } from "./BarChartTableComponent.vue?vue&type=template&id=7debc9ff"
import script from "./BarChartTableComponent.vue?vue&type=script&lang=js"
export * from "./BarChartTableComponent.vue?vue&type=script&lang=js"

import "./BarChartTableComponent.vue?vue&type=style&index=0&id=7debc9ff&lang=css"
script.render = render

export default script